<template>
  <div class="productGallery">
    <div class="productGallery__main">
      <SwiperSlider ref="swiper" class="productGallery__mainSlider" :options="swiperOptions">
        <div
          v-for="(item, index) in gallery"
          :key="index"
          class="productGallery__mainSlide swiper-slide"
        >
          <product-zoom-image
            :alt="alt"
            :image="item.urlFull"
            :image-alt="item.alt"
            :lazy="index !== 0"
            @click="openLightbox(index)"
          />
        </div>
        <div slot="pagination" class="productGallery__mainPagination swiper-pagination"></div>
      </SwiperSlider>
    </div>
    <div class="productGallery__listWrapper" v-if="gallery.length > 1">
      <div class="productGallery__list">
        <div
          :key="index"
          class="productGallery__listItem"
          v-for="(item, index) in gallery"
          v-show="index < 5"
        >
          <button
            :class="[
              'productGallery__listItemInner',
              { 'productGallery__listItemInner--active': activeSlide === index },
            ]"
            @mouseenter="changeSlide(index)"
            @click="openLightbox(index)"
          >
            <new-image-box
              :alt="alt"
              :src="item.urlFull"
              loading="eager"
              :width="100"
              :height="100"
              center-image
              :image-params="'w_100,h_100'"
            />
            <div class="productGallery__listMore" v-if="index === 4 && gallery.length - 5 > 0">
              <span>+{{ gallery.length - 5 }}</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductZoomImage from './ProductZoomImage';
import NewImageBox from '@/components/NewImageBox';
import lightbox from '~/mixins/lightbox';
import SwiperSlider from '~/components/SwiperSlider';

export default {
  name: 'ProductGallery',
  components: {
    SwiperSlider,
    NewImageBox,
    ProductZoomImage,
  },
  mixins: [lightbox],
  props: {
    gallery: {
      type: Array,
      default: () => {},
    },
    alt: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeSlide: 0,
      swiperOptions: {
        effect: !this.$device.isMobileOrTablet ? 'fade' : 'slide',
        fadeEffect: {
          crossFade: true,
        },
        spaceBetween: 0,
        lazy: {
          loadPrevNext: true,
        },
        navigation: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
      },
    };
  },
  computed: {
    swiper() {
      if (typeof this.$refs.swiper.swiper !== 'undefined') {
        return this.$refs.swiper.swiper;
      }
      return false;
    },
    galleryItems() {
      return this.gallery.map(item => item.urlFull);
    },
  },
  methods: {
    openLightbox(index) {
      this.setLightboxItems(this.galleryItems);
      this.setLightboxIndex(index);
    },
    changeSlide(index) {
      if (this.swiper) {
        this.swiper.slideTo(index);
        this.activeSlide = index;
      }
    },
  },
};
</script>

<style lang="scss">
.productGallery {
  $root: &;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  &__main {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 4rem 7rem 1.5rem 4rem;

    @include rwd('laptop') {
      padding: 4rem 5rem 4rem 0;
    }

    @include rwd('large-tablet') {
      padding: 3rem 4rem;
    }

    @include rwd('tablet') {
      flex: 0 0 100%;
      max-width: 100%;
      padding: 3rem 0 0 0;
    }
  }

  &__mainSlider {
    position: relative;
    height: 45rem;

    @include rwd('tablet') {
      height: 36rem;
      padding-bottom: 6rem;
    }
  }

  &__mainPagination {
    bottom: 0;
    display: none;

    @include rwd('tablet') {
      display: block;
    }
  }

  &__mainSlide {
    display: flex;
    align-items: center;
    justify-content: center;
    height: auto;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &__listWrapper {
    width: 100%;
    padding: 0 5rem 0 2rem;

    @include rwd('laptop') {
      padding: 0 3rem 0 0;
    }

    @include rwd('tablet') {
      display: none;
    }
  }

  &__list {
    display: flex;
    justify-content: center;
    width: 100%;

    @include rwd('laptop') {
      margin: 0 -0.5rem;
    }
  }

  &__listItem {
    position: relative;
    padding-left: 0.7rem;
    padding-right: 0.7rem;
    flex: 0 0 20%;
    max-width: 20%;

    @include rwd('laptop') {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }

  &__listItemInner {
    display: flex;
    height: 6.8rem;
    padding: 0.5rem;
    border: 1px solid $cAddLight;
    border-radius: 3px;
    width: 100%;

    &--active {
      border: 1px solid $cAddDark;
    }
  }

  &__listMore {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($cWhite, 0.7);
    font-size: 1.6rem;
    font-weight: 700;
  }
}
</style>
